import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex'

import admin from '@layouts/admin/store.js'
import provider from '@layouts/provider/store.js'
import customer from '@layouts/customer/store.js'
Vue.use(Vuex)

window.config = require('@config/config.js');
const CONFIG = new config();

const store = new Vuex.Store({
    state: {
        style: {
            width: 0,
            height: 0,
        },
        instance_identity: null,
        // 目前大致上先這樣
        // 1. 登入 via host
        // 2. 抓取node via jwt
        // 3. 抓取routes via jwt
        settings: {
            provider: {
                get_routes_url: CONFIG.lms_url + "/v1/provider/routes"
            },
            customer: {
                get_routes_url: CONFIG.lms_url + "/v1/customer/routes"
            },
            captcha_url: CONFIG.lms_url + "/v1/captcha",
            login_url: CONFIG.lms_url + "/v1/authenticate/:node_identity",
            out_of_date_url: CONFIG.lms_url + "/v1/out_of_date",
            authorize_url: CONFIG.lms_url + "/v1/authorize",
            default_language: "zh-TW",
            login_expiration_period: 1*60*60*8,
            login_expiration_hint_preset: 1*60*30,
        },
        current_scope: null,
        language: "zh-TW",
        // for partial/no_permission
        back_two_page: [],
        global_setting: {
            // Seconds
            login_expiration_period: 1*60*60*8,
            login_expiration_hint_preset: 1*60*30,
        },
        routes: {
            get_routes_url: CONFIG.lms_url + "/v1/:app_id/node/:access_token/routes",
        },
        is_login: null,
        initialize_statuses: {
            top_menu: false,
            sidebar: false,
            service_theme: false,
            main: false,
            footer: false
        },
        stations: [],
        operations: [],
        core_waybills: [],
        breadcrumbs: [],
        permissions: [],
        current_staff: {},
        element_ui_datepicker_daterange_options: {
            shortcuts: [{
                i18n_key: "ui.el.daterange_option_shortcut.today",
                date_i18n_key: "ui.el.date_option_shortcut.today",
                text: "今日",
                get_times() {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime())
                    return [
                        start.setHours(0,0,0,0),
                        end.setHours(23,59,59,59)
                    ]
                },
                onClick(picker) {
                    picker.$emit("pick", this.get_times())
                }
            },{
                i18n_key: "ui.el.daterange_option_shortcut.three_days",
                date_i18n_key: "ui.el.date_option_shortcut.three_days",
                text: "最近三天",
                get_times() {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                    return [
                        start.setHours(0,0,0,0),
                        end.setHours(23,59,59,59)
                    ]
                },
                onClick(picker) {
                    picker.$emit("pick", this.get_times())
                }
            }, {
                i18n_key: "ui.el.daterange_option_shortcut.week",
                date_i18n_key: "ui.el.date_option_shortcut.week",
                text: "最近一周",
                get_times() {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    return [
                        start.setHours(0,0,0,0),
                        end.setHours(23,59,59,59)
                    ]
                },
                onClick(picker) {
                    picker.$emit("pick", this.get_times())
                }
            }, {
                i18n_key: "ui.el.daterange_option_shortcut.month",
                date_i18n_key: "ui.el.date_option_shortcut.month",
                text: "最近一個月",
                get_times() {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                    return [
                        start.setHours(0,0,0,0),
                        end.setHours(23,59,59,59)
                    ]
                },
                onClick(picker) {
                    picker.$emit("pick", this.get_times())
                }
            }, {
                i18n_key: "ui.el.daterange_option_shortcut.three_months",
                date_i18n_key: "ui.el.date_option_shortcut.three_months",
                text: "最近三個月",
                get_times() {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3)
                    return [
                        start.setHours(0,0,0,0),
                        end.setHours(23,59,59,59)
                    ]
                },
                onClick(picker) {
                    picker.$emit("pick", this.get_times())
                }
            }, {
                i18n_key: "ui.el.daterange_option_shortcut.six_months",
                date_i18n_key: "ui.el.date_option_shortcut.six_months",
                text: "最近半年",
                get_times() {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6)
                    return [
                        start.setHours(0,0,0,0),
                        end.setHours(23,59,59,59)
                    ]
                },
                onClick(picker) {
                    picker.$emit("pick", this.get_times())
                }
            }]
        },
    },
    getters: {
        test: function(state) {
            return "root";
        },
        operation: function(state) {
            return function(operation_identity) {
                return _.findLast(state.operations, function(operation) {
                    return operation.identity == operation_identity;
                }) || {};
            }
        },
        core_waybill: function(state) {
            return function(core_waybill_identity) {
                return _.findLast(state.core_waybills, function(core_waybill) {
                    return core_waybill.identity == core_waybill_identity;
                }) || {};
            }
        },
        station: function(state) {
            return function(station_identity) {
                return _.findLast(state.stations, function(station) {
                    return station.identity == station_identity;
                }) || {};
            }
        },
        workspace: function(state) {
            return function(workspace_identity) {
                var workspace = {}
                _.forEach(state.stations, function(station) {
                    var target_workspace = _.findLast(station.workspaces, function(workspace) {
                        return workspace.identity == workspace_identity;
                    });

                    if (target_workspace) {
                        workspace = target_workspace;
                        workspace.station = station;
                    }
                })
                return workspace;
            }
        },
        current_station: function(state) {
            return _.findLast(state.provider.stations, function(station) {
                return station.identity == state.provider.current_staff.station_identity;
            }) || {
                identity: null,
                name: null,
            }
        },
        current_operation: function(state) {
            return _.findLast(state.operations, function(operation) {
                return operation.identity == state.route.params.operation_identity
            })
        },
        current_core_waybill: function(state, getters) {
            if (getters.current_operation) {
                return _.findLast(state.core_waybills, function(core_waybill) {
                    return core_waybill.identity == state.route.params.core_waybill_identity
                })
            }
        },
    },
    actions: {
    },
    mutations: {
        set_current_scope: function(state, payload) {
            state.current_scope = payload;
        }
    },
    modules: {
        admin,
        provider,
        customer,
    }
})

export default store
